import { type ComputedRef, type Ref, computed } from 'vue'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import type { MetaTypeKeys } from '~/utils/seo/constants'
import { getMetas } from '~/utils/seo/meta'

export function useProductHeadMeta({
  description,
  productResponse,
  title,
}: {
  description: ComputedRef<string>
  productResponse: Ref<GetProductResponse | null>
  title: ComputedRef<string>
}) {
  const meta = computed(() => {
    if (!productResponse.value) {
      return []
    }

    // checking listing in the URL should be enough
    const metas: Record<MetaTypeKeys | string, string> = {
      title: title.value,
      description: description.value,
      image: productResponse.value.images?.[0]?.url ?? null,
      'og:type': 'product',
    }

    return getMetas(metas)
  })

  return { meta }
}
